/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBookmarkMinus = createReactComponent("outline", "bookmark-minus", "IconBookmarkMinus", [["path", { "d": "M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v8", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

export { IconBookmarkMinus as default };
//# sourceMappingURL=IconBookmarkMinus.mjs.map
